export default __webpack_public_path__ + "static/media/already.54b06a5e.svg";